module.exports = __webpack_public_path__ + "img/alert-success.2e9f03ff.svg";